export default "__VITE_ASSET__CFM0NKRr__"